import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizeService } from '../../services';

@Component({
  selector: 'lib-login-menu',
  styleUrls: ['login-menu.component.scss'],
  templateUrl: 'login-menu.component.html',
  imports: [CommonModule, RouterModule],
})
export class LoginMenuComponent implements OnInit {
  private readonly authorizeService = inject(AuthorizeService);
  public isAuthenticated!: Observable<boolean>;
  public userName!: Observable<string>;

  ngOnInit() {
    this.isAuthenticated = this.authorizeService.isAuthenticated();
    this.userName = this.authorizeService.getUser().pipe(map((u) => u?.name ?? ''));
  }
}
